import { createFileRoute } from '@tanstack/react-router'
import AgreementGeneral from 'Royalty/components/Agreement/AgreementGeneral/AgreementGeneral'

export const Route = createFileRoute('/royalty_/agreement/$id/general')({
    component: AgreementGeneral,
})
